import TTrialApplicationInviteUserSummary from './index.vue';

TTrialApplicationInviteUserSummary.install = app => {
  app.component(TTrialApplicationInviteUserSummary.name, TTrialApplicationInviteUserSummary);
};

export default TTrialApplicationInviteUserSummary;
